import coupon_detail_card_bg from 'src/assets/images/coupon_detail/coupon_detail_card_bg.png'
import coupon_detail_card_bg_no_barcode from 'src/assets/images/coupon_detail/coupon_detail_card_bg_no_barcode.png'
import styled from 'styled-components'
import { Noto_body1_m16 } from 'src/styles/fonts/NotoSansKrFonts'
import { Roboto_num2_b16, Roboto_num2_r16 } from 'src/styles/fonts/RobotoFonts'

const CouponDetailCardBg = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--black-10);
`

const CouponDetailCardContainer = styled.div<{ $barcode: boolean }>`
  display: flex;
  flex-direction: column;
  width: 320px;
  height: ${({ $barcode }) => ($barcode ? 394 : 301)}px;
  margin: 20px auto;
  gap: 60px;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  background: url(${({ $barcode }) =>
      $barcode ? coupon_detail_card_bg : coupon_detail_card_bg_no_barcode})
    no-repeat center/contain;
`

const CouponDetailCardTopContents = styled.section<{ $height?: string }>`
  display: flex;
  flex-direction: column;
  height: ${(props) => props.$height || '180px'};
  margin-top: 10px;
`

const CouponDetailCardBottomContents = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 104px;
`

const CouponDetailInfoList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 10px;
`

const CouponDetailInfoListLine = styled.div<{ $disabled?: boolean }>`
  width: 100%;
  display: ${(props) => (props.$disabled ? 'none' : 'flex')};
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  & > span:nth-child(2) {
    padding-top: 2.5px;
  }
`
const CouponDetailInfoListLineTitle = styled.span`
  ${Noto_body1_m16};
  margin-right: 20px;
  color: var(--black-50);
  white-space: nowrap;
`
const CouponDetailInfoListLineDesc = styled.span<{ $bold?: boolean; $color?: string }>`
  ${({ $bold }) => ($bold ? Roboto_num2_b16 : Roboto_num2_r16)};
  color: ${({ $color }) => $color || 'var(--black-70)'};
`

export const CouponDetailCard = {
  Bg: CouponDetailCardBg,
  Container: CouponDetailCardContainer,
  Top: CouponDetailCardTopContents,
  Bottom: CouponDetailCardBottomContents,
  DetailInfoList: CouponDetailInfoList,
  DetailInfoLine: CouponDetailInfoListLine,
  DetailTitle: CouponDetailInfoListLineTitle,
  DetailDesc: CouponDetailInfoListLineDesc,
}
